import { render, staticRenderFns } from "./imgI.vue?vue&type=template&id=36b82990"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b82990')) {
      api.createRecord('36b82990', component.options)
    } else {
      api.reload('36b82990', component.options)
    }
    module.hot.accept("./imgI.vue?vue&type=template&id=36b82990", function () {
      api.rerender('36b82990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgI.vue"
export default component.exports